import React from "react";
import "../styles/Awards.scss";
import GenderStudiesImg from "../assets/Gender studies.png";
import SocialScienceImg from "../assets/category icon.png";

function ScholarAwards() {
  return (
    <div className="scholar-awards">
     <div className="pen-scholar-heading">
        <h1>PEN</h1>
        <h2>Scholar Awards 2025</h2>
</div>
      <div className="scholar-content">
        <p>Celebrating Excellence in Research</p>

        <div className="image-section">
          <img src={GenderStudiesImg} alt="Gender Studies" />
          <img src={SocialScienceImg} alt="Social Science" />
        </div>
      </div>
    </div>
  );
}

export default ScholarAwards;
